import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

class ReturnsAndCancellation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
    };
  }

  render() {
    const { isLoaded } = this.state;

    return (
      <div style={containerStyle}>
        <h2 style={headerStyle}>Returns & Cancellation</h2>
        {!isLoaded ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <p style={textStyle}>
            JC Creations does not provide refunds or re-credits for downloaded files. Requests for file returns will only be entertained in instances of technical issues with the file, subject to the sole discretion of JC Creations. The site management retains the right to initially address and resolve any technical concerns, which may involve offline correction of the final artwork for the customer.
          </p>
        )}
      </div>
    );
  }
}

const containerStyle = {
  background: "linear-gradient(to bottom right, #fff8f2, #fde9e0)",
  padding: "40px 20px",
  fontFamily: "Arial, sans-serif",
  minHeight: "100vh",
  color: "#444",
};

const headerStyle = {
  fontSize: "28px",
  fontWeight: "bold",
  color: "#b0452b",
  textAlign: "center",
  marginBottom: "20px",
};

const textStyle = {
  fontSize: "16px",
  lineHeight: "1.8",
  maxWidth: "800px",
  margin: "0 auto",
};

export default ReturnsAndCancellation;
